// FROM: https://github.com/modusign/modusign-client/blob/b6c3d577fdd8384ea2f73c5ab605ead1afc782d1/app/src/components/MouseFieldPlaceholder/CheckboxGroupMousePlaceholder/index.tsx

import { Box } from '@modusign/design-system';
import cx from 'classnames';

import { CheckboxFieldCheck } from '@app/components/CheckboxField';
import { AbsoluteNumber } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import createFieldClassNameByParticipantOrder from '@app/libs/participantFields/createFieldClassNameByParticipantOrder';
import orderRotationForColor from '@app/libs/participantFields/orderRotationForColor';

import './CheckboxGroupMousePlaceholder.scss';

interface CheckboxMousePlaceholderProps {
  size: AbsoluteNumber;
  showStar?: boolean;
  participantOrder: number;
}

const defaultProps = {
  order: 1,
  scale: 1,
};

function CheckboxGroupMousePlaceholder({
  showStar,
  size,
  participantOrder,
}: CheckboxMousePlaceholderProps) {
  const checkboxGroupMousePlaceholderCheckboxClassByOrder = createFieldClassNameByParticipantOrder(
    'CheckboxGroupMousePlaceholder__checkbox',
    participantOrder
  );

  // FIXME: 아래 스타일링은 기존 CheckboxFieldPlaceholder의 것을 유지합니다.
  // 체크박스 그룹을 위해, CheckboxFieldPlaceholder을
  // CheckboxGroupPlaceholder로 이름을 바꿉니다.
  // 추후 서명자 순서 관련 변경이 필요할 리팩토링 해야합니다.
  const className = cx(
    'CheckboxGroupMousePlaceholder__checkbox',
    checkboxGroupMousePlaceholderCheckboxClassByOrder
  );

  return (
    <Box marginLeft="-6px" marginTop="-6px">
      {!!showStar && <div className="CheckboxGroupMousePlaceholder__star">*</div>}
      <Box
        border="2px dashed"
        borderColor={`participantOrder${orderRotationForColor(participantOrder)}`}
        borderRadius="3px"
        height="100%"
        width="100%"
      >
        <Box padding="6px">
          <Box className={className} height="100%" width="100%">
            <CheckboxFieldCheck height={size} width={size} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

CheckboxGroupMousePlaceholder.defaultProps = defaultProps;

export default CheckboxGroupMousePlaceholder;
